import React, { useEffect, useState } from 'react'
import ConfirmPickZoneModal from '../Km/ConfirmPickZoneModal/ConfirmPickZoneModal'
import { Link, Route, Switch } from 'react-router-dom'

import Distance from '../Distance/Distance'
import City from '../City/City'

export default function CalculateOptions({ type, idx, setType }) {
	// const navigate = useNavigate()
	const [image, setImage] = useState()
	const [mainText, setMainText] = useState()
	const [description, setDescription] = useState()
	const [typeClicked, setTypeClicked] = useState()
	const [id, setId] = useState(null)
	const [showModal2, setShowModal2] = useState(false)
	const [deleted, setDeleted] = useState(false)
	const [idToDelete, setIdToDelete] = useState(null)
	const [distance, setDistance] = useState(false)
	const [city, setCity] = useState(false)

	const setRows = () => {
		if (type === 'distance') {
			setImage(
				<svg
					width='40'
					height='40'
					viewBox='0 0 40 40'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'>
					<rect width='40' height='40' rx='8' fill='#EC4899' />
					<path
						d='M13.47 17C15.403 17 16.97 15.433 16.97 13.5C16.97 11.567 15.403 10 13.47 10C11.537 10 9.96997 11.567 9.96997 13.5C9.96997 15.433 11.537 17 13.47 17Z'
						stroke='white'
						strokeWidth='1.5'
					/>
					<path
						d='M24.97 23H27.97C29.07 23 29.97 23.9 29.97 25V28C29.97 29.1 29.07 30 27.97 30H24.97C23.87 30 22.97 29.1 22.97 28V25C22.97 23.9 23.87 23 24.97 23Z'
						stroke='white'
						strokeWidth='1.5'
					/>
					<path
						d='M19.9999 13H22.6799C24.5299 13 25.3899 15.29 23.9999 16.51L16.0099 23.5C14.6199 24.71 15.4799 27 17.3199 27H19.9999'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M13.4862 13.5H13.4978'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M26.4862 26.5H26.4978'
						stroke='white'
						strokeWidth='2'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			)
			setMainText('Odległość')
			setDescription('Zalecane: Miasta')
		} else if (type === 'city') {
			setImage(
				<svg
					width='40'
					height='40'
					viewBox='0 0 40 40'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'>
					<rect width='40' height='40' rx='8' fill='#F59E0B' />
					<path
						d='M19 28C23.9706 28 28 23.9706 28 19C28 14.0294 23.9706 10 19 10C14.0294 10 10 14.0294 10 19C10 23.9706 14.0294 28 19 28Z'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M26.9299 28.6898C27.4599 30.2898 28.6699 30.4498 29.5999 29.0498C30.4499 27.7698 29.8899 26.7198 28.3499 26.7198C27.2099 26.7098 26.5699 27.5998 26.9299 28.6898Z'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			)
			setMainText('Nazwa miejscowości')
			setDescription('Zalecane: Małe miasta / wsie')
		} else if (type === 'timeOfTravel') {
			setImage(
				<svg
					width='40'
					height='40'
					viewBox='0 0 40 40'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'>
					<rect width='40' height='40' rx='8' fill='#8B5CF6' />
					<path
						d='M30 20C30 25.52 25.52 30 20 30C14.48 30 10 25.52 10 20C10 14.48 14.48 10 20 10C25.52 10 30 14.48 30 20Z'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
					<path
						d='M23.7099 23.1798L20.6099 21.3298C20.0699 21.0098 19.6299 20.2398 19.6299 19.6098V15.5098'
						stroke='white'
						strokeWidth='1.5'
						strokeLinecap='round'
						strokeLinejoin='round'
					/>
				</svg>
			)
			setMainText('Czas podróży')
			setDescription('Zalecane: Zakorkowane miasta')
		}
	}

	useEffect(() => {
		setRows()
	}, [])

	const choosePickUpCalc = value => {
		setType(type);
		setDeleted(value)
		setShowModal2(false)
		if (idx == 1) {
			setDistance(true)
		}
		if (idx == 2) {
			setCity(true)
			// navigate('/distance')
		}
		if (idx == 3) {
			// setDistance(true)
		}
	}

	return (
		<>
			<div
				className={`${
					type === 'timeOfTravel' ? 'border-bottom border-top' : ''
				}w-full flex border-top `}
				onClick={() => {
					type !== 'timeOfTravel' ? setShowModal2(true) : setShowModal2(false);
					setIdToDelete(idx)
				}}>
				<div className='w-full flex flex-row py-3 '>
					<div className='mb-6 md:mb-0 grow pr-3'>{image}</div>
					<div className='flex flex-column m-0 p-0 w-11/12'>
						<p
							className={`${
								type === 'timeOfTravel' ? 'text-lightgray' : 'text-darkgray'
							} p-0 m-0 text-sm   font-bold  `}>
							{mainText}
						</p>
						<p
							className={`${
								type === 'timeOfTravel' ? 'text-lightgray' : 'text-darkgray'
							} p-0 m-0 text-sm `}>
							{description}
						</p>
					</div>
					<div className='m-auto'>
						{type === 'timeOfTravel' ? (
							<svg
								width='69'
								height='20'
								viewBox='0 0 69 20'
								fill='none'
								xmlns='http://www.w3.org/2000/svg'>
								<path
									d='M0 10C0 4.47715 4.47715 0 10 0H59C64.5228 0 69 4.47715 69 10C69 15.5228 64.5229 20 59 20H10C4.47715 20 0 15.5228 0 10Z'
									fill='#F3F4F6'
								/>
								<path
									d='M13.0387 14L10.6183 5.27273H12.0032L13.7035 12.0312H13.7844L15.5529 5.27273H16.9251L18.6935 12.0355H18.7745L20.4705 5.27273H21.8597L19.435 14H18.1097L16.2731 7.46307H16.2049L14.3683 14H13.0387ZM24.13 11.7798L24.1214 10.2244H24.343L26.951 7.45455H28.4766L25.5021 10.608H25.3018L24.13 11.7798ZM22.9581 14V5.27273H24.2322V14H22.9581ZM27.0916 14L24.7479 10.8892L25.6257 9.99858L28.6555 14H27.0916ZM29.6378 14V7.45455H30.8693V8.49432H30.9375C31.0568 8.14205 31.267 7.86506 31.5682 7.66335C31.8722 7.45881 32.2159 7.35653 32.5994 7.35653C32.679 7.35653 32.7727 7.35937 32.8807 7.36506C32.9915 7.37074 33.0781 7.37784 33.1406 7.38636V8.60511C33.0895 8.59091 32.9986 8.57528 32.8679 8.55824C32.7372 8.53835 32.6065 8.52841 32.4759 8.52841C32.1747 8.52841 31.9063 8.59233 31.6705 8.72017C31.4375 8.84517 31.2528 9.01989 31.1165 9.24432C30.9801 9.46591 30.9119 9.71875 30.9119 10.0028V14H29.6378ZM36.766 14.1321C36.1523 14.1321 35.6168 13.9915 35.1594 13.7102C34.7021 13.429 34.3469 13.0355 34.0941 12.5298C33.8413 12.0241 33.7148 11.4332 33.7148 10.7571C33.7148 10.0781 33.8413 9.48437 34.0941 8.97585C34.3469 8.46733 34.7021 8.07244 35.1594 7.79119C35.6168 7.50994 36.1523 7.36932 36.766 7.36932C37.3796 7.36932 37.9151 7.50994 38.3725 7.79119C38.8299 8.07244 39.185 8.46733 39.4379 8.97585C39.6907 9.48437 39.8171 10.0781 39.8171 10.7571C39.8171 11.4332 39.6907 12.0241 39.4379 12.5298C39.185 13.0355 38.8299 13.429 38.3725 13.7102C37.9151 13.9915 37.3796 14.1321 36.766 14.1321ZM36.7702 13.0625C37.168 13.0625 37.4975 12.9574 37.7589 12.7472C38.0202 12.5369 38.2134 12.2571 38.3384 11.9077C38.4663 11.5582 38.5302 11.1733 38.5302 10.7528C38.5302 10.3352 38.4663 9.9517 38.3384 9.60227C38.2134 9.25 38.0202 8.96733 37.7589 8.75426C37.4975 8.54119 37.168 8.43466 36.7702 8.43466C36.3697 8.43466 36.0373 8.54119 35.7731 8.75426C35.5117 8.96733 35.3171 9.25 35.1893 9.60227C35.0643 9.9517 35.0018 10.3352 35.0018 10.7528C35.0018 11.1733 35.0643 11.5582 35.1893 11.9077C35.3171 12.2571 35.5117 12.5369 35.7731 12.7472C36.0373 12.9574 36.3697 13.0625 36.7702 13.0625ZM36.2418 6.58097L37.239 4.61648H38.5813L37.2603 6.58097H36.2418ZM44.2947 7.45455V8.47727H40.7195V7.45455H44.2947ZM41.6783 5.88636H42.9524V12.0781C42.9524 12.3253 42.9893 12.5114 43.0632 12.6364C43.1371 12.7585 43.2322 12.8423 43.3487 12.8878C43.468 12.9304 43.5973 12.9517 43.7365 12.9517C43.8388 12.9517 43.9283 12.9446 44.005 12.9304C44.0817 12.9162 44.1413 12.9048 44.1839 12.8963L44.4141 13.9489C44.3402 13.9773 44.2351 14.0057 44.0987 14.0341C43.9624 14.0653 43.7919 14.0824 43.5874 14.0852C43.2521 14.0909 42.9396 14.0312 42.6499 13.9062C42.3601 13.7812 42.1257 13.5881 41.9467 13.3267C41.7678 13.0653 41.6783 12.7372 41.6783 12.3423V5.88636ZM48.391 14.1321C47.7575 14.1321 47.212 13.9886 46.7546 13.7017C46.3001 13.4119 45.9506 13.0128 45.7063 12.5043C45.462 11.9957 45.3398 11.4134 45.3398 10.7571C45.3398 10.0923 45.4648 9.50568 45.7148 8.99716C45.9648 8.4858 46.3171 8.08665 46.7717 7.79972C47.2262 7.51278 47.7617 7.36932 48.3782 7.36932C48.8754 7.36932 49.3185 7.46165 49.7077 7.64631C50.0969 7.82812 50.4109 8.08381 50.6495 8.41335C50.891 8.7429 51.0344 9.12784 51.0799 9.56818H49.8398C49.7717 9.26136 49.6154 8.99716 49.3711 8.77557C49.1296 8.55398 48.8058 8.44318 48.3995 8.44318C48.0444 8.44318 47.7333 8.53693 47.4663 8.72443C47.2021 8.90909 46.9961 9.1733 46.8484 9.51705C46.7006 9.85795 46.6268 10.2614 46.6268 10.7273C46.6268 11.2045 46.6992 11.6165 46.8441 11.9631C46.989 12.3097 47.1935 12.5781 47.4577 12.7685C47.7248 12.9588 48.0387 13.054 48.3995 13.054C48.641 13.054 48.8597 13.0099 49.0558 12.9219C49.2546 12.831 49.4208 12.7017 49.5543 12.5341C49.6907 12.3665 49.7859 12.1648 49.8398 11.929H51.0799C51.0344 12.3523 50.8967 12.7301 50.6665 13.0625C50.4364 13.3949 50.1282 13.6562 49.7418 13.8466C49.3583 14.0369 48.908 14.1321 48.391 14.1321ZM55.2635 14.1321C54.6186 14.1321 54.0632 13.9943 53.5973 13.7188C53.1342 13.4403 52.7763 13.0497 52.5234 12.5469C52.2734 12.0412 52.1484 11.4489 52.1484 10.7699C52.1484 10.0994 52.2734 9.50852 52.5234 8.99716C52.7763 8.4858 53.1286 8.08665 53.5803 7.79972C54.0348 7.51278 54.5661 7.36932 55.174 7.36932C55.5433 7.36932 55.9013 7.4304 56.2479 7.55256C56.5945 7.67472 56.9055 7.86648 57.1811 8.12784C57.4567 8.3892 57.674 8.72869 57.8331 9.14631C57.9922 9.56108 58.0717 10.0653 58.0717 10.6591V11.1108H52.8686V10.1562H56.8232C56.8232 9.82102 56.755 9.52415 56.6186 9.26562C56.4822 9.00426 56.2905 8.7983 56.0433 8.64773C55.799 8.49716 55.5121 8.42188 55.1825 8.42188C54.8246 8.42188 54.5121 8.50994 54.245 8.68608C53.9808 8.85937 53.7763 9.08665 53.6314 9.3679C53.4893 9.64631 53.4183 9.94886 53.4183 10.2756V11.0213C53.4183 11.4588 53.495 11.831 53.6484 12.1378C53.8047 12.4446 54.022 12.679 54.3004 12.8409C54.5788 13 54.9041 13.0795 55.2763 13.0795C55.5178 13.0795 55.7379 13.0455 55.9368 12.9773C56.1357 12.9062 56.3075 12.8011 56.4524 12.6619C56.5973 12.5227 56.7081 12.3509 56.7848 12.1463L57.9908 12.3636C57.8942 12.7187 57.7209 13.0298 57.4709 13.2969C57.2237 13.5611 56.9126 13.767 56.5376 13.9148C56.1655 14.0597 55.7408 14.1321 55.2635 14.1321Z'
									fill='#1F2937'
								/>
							</svg>
						) : (
							<div>
								<svg
									xmlns='http://www.w3.org/2000/svg'
									width='16'
									height='16'
									fill='gray'
									className='bi bi-chevron-right'
									viewBox='0 0 16 16'>
									<path
										fillRule='evenodd'
										d='M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708z'
									/>
								</svg>
							</div>
						)}
					</div>
				</div>
			</div>
			{showModal2 ? (
				<ConfirmPickZoneModal
					choosePickUpCalc={choosePickUpCalc}
					cancel={setShowModal2}
				/>
			) : (
				''
			)}
		</>
	)
}
